/* eslint-disable @typescript-eslint/indent */
import { useAppDispatch } from '../../../hooks/redux'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { swalAttentionLeave, swalOptions } from '../../../functions/swalOptions'
import Swal from 'sweetalert2'

import { registerLocale } from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import { type Unit } from '../../../store/slices/unitsSlice'

import { type ISettings } from '../../../store/slices/userSlice'
import useUserType from '../../../hooks/UseUserType'
import { areUnitActionButtonsBlocked } from '../../../functions/shared/units/getUnitOfferStatus'
import { setUnitHidden, setUnitSold } from '../../../store/actionsCreators/unitsActions'
import { getRelistTargetUnitId } from '../../../functions/shared/units/unitReviewActivity'

import checkIfUnitHasOngoingTransactions from "../../../functions/shared/units/checkIfUnitHasOngoingTransactions";

import { manageVerifiedRejectAgentUnit } from '../../../store/actionsCreators/unitActions/manageVerifiedRejectAgentUnit'
import { USER_ID_KEY } from '../../../urls'
import { useAppSelector } from '../../../hooks/redux'
import { type RootState } from '../../../store/store'
import { isExternalRequestedUnit } from '../../../functions/shared/units/unitVisibility'
import { getUnitCardActionAccess } from './unitCardActionAccess'

registerLocale(en)

interface IProps {
    unit: Unit
    fromEntry: string | undefined
    settings?: ISettings[]
}

export default function ButtonsActionsSh({ fromEntry, unit, settings }: IProps): JSX.Element {
    // console.log(fromEntry, "fromEntry")
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const userID = window.localStorage.getItem(USER_ID_KEY)
    const { userType, userTypeLowercase } = useUserType()
    const myPublishedUnitsOpen = useAppSelector((state: RootState) => state.units.myPublishedUnitsOpen)



    const blockAgentButtons = areUnitActionButtonsBlocked(unit)




    const [actionLoading, setActionLoading] = useState(false)
    const unitHasOngoingTransactions = checkIfUnitHasOngoingTransactions(unit.id)
    const relistTargetUnitId = getRelistTargetUnitId(unit.attributes?.UnitReview)



    const { isForeignLandlordOrAgentUnit, canManageUnit } = getUnitCardActionAccess(unit, userID)
    const isInRequest = isExternalRequestedUnit(unit)
    const needsVerificationReview = unit?.attributes?.Statuses?.includes('Registered') === true
    const isPublishedCatalogContext = userType === 'Landlord' && myPublishedUnitsOpen && !isInRequest

    const confirmManualOffMarket = async (): Promise<void> => {
        const outcome = unit?.attributes?.Marketing?.Use === 'For sale' ? 'sold' : 'rented'
        const result = await Swal.fire({
            ...swalOptions('warning'),
            title: `Set unit ${outcome}`,
            html: `<p>${String(unit.attributes?.Marketing?.Headline ?? `Unit #${String(unit.id)}`)}</p><label class="form-label">Reason</label><select id="off-market-reason" class="form-select"><option value="landlord_removed_unit">Landlord removed unit</option><option value="other">Other</option></select><label class="form-label mt-3">Note</label><textarea id="off-market-note" class="form-control" placeholder="Required when Other is selected"></textarea>`,
            showCancelButton: true,
            confirmButtonText: `Confirm ${outcome}`,
            preConfirm: () => {
                const reason = (document.getElementById('off-market-reason') as HTMLSelectElement | null)?.value
                const note = (document.getElementById('off-market-note') as HTMLTextAreaElement | null)?.value.trim() ?? ''
                if (reason === 'other' && note === '') {
                    Swal.showValidationMessage('A note is required when Other is selected.')
                    return false
                }
                return { reason, note }
            }
        })
        if (!result.isConfirmed || result.value == null) return
        setActionLoading(true)
        void dispatch(setUnitSold(unit.id, false, undefined, {
            reason: result.value.reason,
            outcome,
            source: 'admin',
            ...(result.value.note !== '' ? { note: result.value.note } : {})
        })).finally(() => setActionLoading(false))
    }



    return (
        <>
            {isForeignLandlordOrAgentUnit ?
                <div className="col-12 px-3">
                    <button
                        type="button"
                        className="btn btn-bso m-0 fs-6 p-1 py-3 w-100"
                        onClick={() => {
                            navigate(`/landlord/modalView/unit_modal/${unit.id}/not/other_agent_s_unit`)
                        }}
                    >{needsVerificationReview ? 'Review & Verify' : 'Review'}</button>
                </div>
                : isInRequest ?
                userType === "Landlord" && unit?.attributes.User?.data?.id !== Number(userID) ?
                    <div className="col-12">
                        <div
                            className={`btn btn-bso m-0 fs-6 p-1 py-3 w-100 ${blockAgentButtons ? 'opacity-50' : 'opacity-100'}`}
                            onClick={() => {
                                navigate(`/landlord/modalView/unit_modal/${unit?.id}/not/other_agent_s_unit`)
                            }}
                        >
                            Review & Verify
                        </div>
                    </div>
                    : <div className="col-12">
                        <div className="btn btn-bso  m-0 fs-6 p-1 py-3  w-100 "
                            // eslint-disable-next-line @typescript-eslint/no-misused-promises
                            onClick={async () => {
                                await swalAttentionLeave("Are you shure <strong>cancel request for verification?</strong>").then(async (result: any) => {
                                    if (result.isConfirmed) {
                                        dispatch(manageVerifiedRejectAgentUnit(
                                            {
                                                unitID: unit.id,
                                                body: { Statuses: ['Drafted'] }
                                            }
                                        ))
                                    }
                                }).catch(console.log);
                            }}
                        >Cancel</div></div>

                :
                <div className="d-flex flex-column m-0 px-3">
                    <div className="unit-card-actions">
                        {canManageUnit && fromEntry === 'myUnitsAgent' && !isPublishedCatalogContext && (
                            !actionLoading
                                ?

                                <>
                                    <div className="col">
                                        <Link to={`/${userTypeLowercase}/set_unit_modal/edit_unit_modal/${unit.id}/${unit.attributes.Property?.data?.id ?? 0}`} className="text-decoration-none">
                                            <div className="btn btn-bso unit-card-action">Edit</div>
                                        </Link>
                                    </div>

                                    {
                                        unit.attributes.Statuses?.includes('Sold')
                                            ?
                                            <div className="col d-flex">
                                                {relistTargetUnitId != null
                                                    ? <button type="button" className="btn btn-outline-secondary unit-card-action" onClick={() => navigate(`/landlord/modalView/unit_modal/${String(relistTargetUnitId)}/not/catalog`)}>Relisted to<br />#{relistTargetUnitId}</button>
                                                    : <button type="button" className="book-viewing-button unit-card-action" onClick={() => navigate(`/${userTypeLowercase}/relist_unit/${String(unit.id)}`)}>Relist to market</button>}
                                            </div>
                                            : <div className="col" onClick={() => { void confirmManualOffMarket() }}>
                                                <div className="btn btn-dark unit-card-action cursor-pointer">
                                                    {
                                                        unit?.attributes?.Marketing?.Use === 'For sale'
                                                            ? <> Set sold </>
                                                            : <> Set rented </>
                                                    }
                                                </div>
                                            </div>

                                    }

                                    {unit?.attributes?.Statuses?.includes('Drafted') ?
                                            <div className="col" onClick={() => {
                                            setActionLoading(true)
                                            void dispatch(setUnitHidden(unit.id, true))
                                                .finally(() => {
                                                    setActionLoading(false)
                                                })
                                        }}>
                                            <div className="book-viewing-button unit-card-action cursor-pointer">Show in market</div>
                                        </div>
                                        : <div className="col" onClick={() => {
                                            if (!unitHasOngoingTransactions) {
                                                setActionLoading(true)
                                                void dispatch(setUnitHidden(unit.id, false))
                                                    .finally(() => {
                                                        setActionLoading(false)
                                                    })
                                            }
                                        }}>
                                            <div className={`btn ${unitHasOngoingTransactions ? 'btn-secondary' : 'btn-dark'} unit-card-action cursor-pointer`}>
                                                Hide from market
                                            </div>
                                        </div>}
                                </>

                                : <>
                                    <div className="btn btn-bso  m-0 fs-6 p-1 py-3 w-100">Loading...</div>
                                </>
                        )}
                    </div>
                </div >
            }
        </>
    )
}
